import ArrondissementPage from "../ArrondissementPage";
import { arrondissementsData } from "@/mocks/arrondissements";

export default function ParisArrOuestPage() {
  const data = arrondissementsData.find((a) => a.slug === "ouest")!;
  return <ArrondissementPage data={data} />;
}
